import { PersonCheckerType } from '../types/personChecker.type';
import { AssetType } from '../types/asset.type';
import { InputType, QuestionDependencyType, QuestionType } from '../types/question.type';
import { IAddresses } from './user.interface';

export interface IInputCheckListSelectOption {
  option: string;
  selected: boolean;
  multi_select_enabled: boolean;
}
export interface IAPIResponseVehicleMakes {
  motorVehicleMakes?: Array<string>;
}
export interface IAPIResponseVehicleModels {
  motorVehicleModels?: Array<IVehicleMakeModel>;
}
export interface IAPIResponseMotorVehicles {
  motorVehicles: Array<IResponseMotorVehicles>;
}
export interface IResponseMotorVehicles {
  id: string;
  model?: IVehicleMakeModel;
  variant: string;
  valueNew: number;
  valueRetail: number;
  valueTrade: number;
  sum_insured: number;
}

export interface IResponseMotorVehiclesSnakeCase {
  id: string;
  model?: IVehicleMakeModel;
  variant: string;
  value_new: number;
  value_retail: number;
  value_trade: number;
  sum_insured: number;
}


export interface IVehicleMakeModel {
  make: string;
  name: string;
  year: number;
}

export interface IVheicleType {
  code: string;
  description: string;
}


//  ------------- for Model Lookup selector
export interface IVehicleLookupDetail {
  id: string;
  make: string;
  model: string;
  sum_insured: number;
  valueNew: number;
  valueRetail: number;
  valueTrade: number;
  variant: string;
  year: number;
}

interface ModelVariant {
  [variant: string]: IVehicleLookupDetail;
}

interface VehicleModel {
  [model: string]: ModelVariant;
}

interface VehicleMake {
  [make: string]: VehicleModel;
}

export interface IVehicleLookupYearMap {
  [year: string]: VehicleMake;
}

//  ------------- for Model Lookup selector


export interface IMotorSaveObject {
  database_field_name: string;
  database_value: any;
}

export interface IPersonChecker {
  key: string;
  triggerWording: string;
  source: string;
  type: PersonCheckerType;
}

export interface IQuestion {
  heading: string;
  sub_heading: string;
  sub_paragraph: string;
  portal_filter_category: string;
  order?: number;
  copy_buildings_and_contents?: boolean;
  type?: QuestionType;
  question_type?: QuestionType;
  wording?: string;
  wording_for_summary?: string;
  underwriting_answers?: Array<UnderwritingAnswer>;
  options?: Array<string>;
  dependency?: IQuestionDependency;
  person_checker?: IPersonChecker;
  claims_prefill_type?: PersonCheckerType;
  disable?: boolean;
  view_on_summary?: boolean;
}

export interface IQuestionDependency {
  dependency_key: string;
  dependency_type: QuestionDependencyType;
  display_when_parent_value_equals: string;
}

export interface UnderwritingAnswer {
  copy_buildings_and_contents?: boolean;
  hidden?: boolean;
  max?: number;
  min?: number;
  regex?: string;
  object_field?: string;
  object_name?: AssetType;
  place_holder?: string;
  required?: boolean;
  answers_old?: Array<string>;
  answer?: any; // this is the default answer for hidden quesitons.
  object_answer?: any;
  object_answer_error?: any;
  input_type?: InputType;
  claims_prefill?: any;
  defualt_zero?: boolean;
  address_object?: IAddresses;
  object_definitions? : Array<IUnderwritingAswerObjectDefinitions>;
}

export interface IUnderwritingAswerObjectDefinitions {
  field?: string;
  options?: Array<string>;
  position?: number;
  type?: string;
}

export interface IQuestionListSelect extends IQuestion {
  checklist_select_options: Array<IInputCheckListSelectOption>;
}

export interface IQuestionGroup {
  index?: number;
  size?: number;
  width_of_progress_bar?: number;
  total_answered?: number;
  answeredQuestions?: IQuestion[];
  headings?: string;
}

export interface ITrackingDevices {
  device_name: string;
  id?: number;
  is_first_tracker: boolean;
  is_second_tracker: boolean;
}
